import { React} from 'react'
import { Container, Nav, Navbar, Offcanvas, Row, Stack, Dropdown } from 'react-bootstrap';


export default function Navigation(props) {
    const handleLogout = () => {
        // Clear localStorage
        localStorage.removeItem('ukies-webinars-admin');
        localStorage.removeItem('ukies-webinars-accessToken');
        
        // Redirect to login
        window.location.href = '/ukies-admin';
    };

    return (
        <Container className='ukies-webinar-nav'>
            <Navbar expand='xl' variant="dark">
                <Container fluid className='px-3 lg:px-8' style={{maxWidth:'80rem'}}>
                    <Navbar.Toggle aria-controls={'offcanvasNavbar-expand-xl'}/>
                    <Navbar.Offcanvas
                        id={'offcanvasNavbar-expand-xl'}
                        aria-labelledby={'offcanvasNavbarLabel-expand-xl'}
                        placement="end"
                        className='ukies-webinar-nav-offcanvas'
                    >
                        <Offcanvas.Header closeButton className='btn-close-white'>
                            <Offcanvas.Title id={'offcanvasNavbarLabel-expand-xl'}>
                                Menu
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="justify-content-start flex-grow-1 pe-3">
                                <Nav.Link href="/ukies-admin" className={props.currentPage == 'home' ? 'active' : ''}>Home</Nav.Link>
                                <Nav.Link href="/ukies-admin/series" className={props.currentPage == 'series' ? 'active' : ''}>Series</Nav.Link>
                                <Nav.Link href="/ukies-admin/testing" className={props.currentPage == 'testing' ? 'active' : ''}>Testen</Nav.Link>
                                <Nav.Link href="/ukies-admin/files" className={props.currentPage == 'files' ? 'active' : ''}>Bestanden</Nav.Link>
                                <Nav.Link href="/ukies-admin/pages" className={props.currentPage == 'pages' ? 'active' : ''}>Paginas</Nav.Link>
                                <Nav.Link href="/ukies-admin/selections" className={props.currentPage == 'selections' ? 'active' : ''}>Selecties</Nav.Link>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                    <Dropdown align="end">
                        <Dropdown.Toggle variant="link" id="user-dropdown" className="text-white text-decoration-none border-0 shadow-none" style={{fontSize:'0.8rem'}}>
                            {props.user.firstName} {props.user.lastName}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleLogout}>
                                Uitloggen
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Container>
            </Navbar>
        </Container>
    );
}